import React from 'react'
import injectSheet from 'react-jss'
import {
  TransitionGroup,
  CSSTransition,
} from 'react-transition-group'

const HouseType = (props) => {
  const {
    children,
    classes,
    transitionKey,
    theme,
  } = props

  return (
    <div className={`${classes.mainContainer}`}>
      <TransitionGroup>
        <CSSTransition
          key={transitionKey}
          classNames="swish"
          timeout={theme.speed.slow}
          mountOnEnter
          unmountOnExit
        >
          {children}
        </CSSTransition>
      </TransitionGroup>
    </div>
  )
}

const styles = theme => ({
  mainContainer: {
    height: '100%',
    width: '100%',
    position: 'relative',
    '& .appear-element': {
      opacity: 1,
      transform: 'translateY(0)',
      transition: [
        {
          property: 'opacity',
          duration: theme.speed.fast,
          delay: theme.speed.fast,
        },
        {
          property: 'transform',
          duration: theme.speed.fast,
          timingFunction: theme.motion.deceleration,
        },
      ],
    },
    '& .swish-enter': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      '& .appear-element': {
        transform: 'translateY(150px)',
        opacity: 0,
      },
    },
    '& .swish-enter.swish-enter-active': {
      '& .appear-element': {
        transform: 'translateY(0)',
        opacity: 1,
      },
    },
    '& .swish-exit': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      '& .appear-element': {
        transform: 'translateY(150px)',
        opacity: 0,
      },
    },
    '& .swish-exit.swish-exit-active': {
      '& .appear-element': {
        transform: 'translateY(0)',
        opacity: 1,
      },
    },
  },
})

export default injectSheet(styles)(HouseType)



// WEBPACK FOOTER //
// ./src/modules/core/components/appearContainer.jsx